import request from '../../request';
import { ACCESS_TOKEN_KEY, getStringFromStorageGenerator } from '../../../utils/local-storage';

export function loginAPI(data: any) {
  data.grant_type = 'password';
  data.client_id = process.env.REACT_APP_CLIENT_ID
  return request(
    {
      url: '/api/auth/token',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function registrationCustomerAPI(data: any) {
  return request(
    {
      url: '/api/auth/signup/',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function meAPI() {
  return request(
    {
      url: '/api/v1/users/me/',
      method: 'GET',
    },
    true
  );
}
export function logoutAPI() {
  const data = {
    token: getStringFromStorageGenerator(ACCESS_TOKEN_KEY),
    client_id: process.env.REACT_APP_CLIENT_ID
  }
  return request(
    {
      url: '/api/auth/token/revoke',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function changePasswordAPI(data: any) {
    return request(
        {
            url: '/api/auth/change-password/',
            method: 'POST',
            data:data,
        },
        true
    );
}

export function completeRegistrationAPI(data: any) {
  return request(
    {
      url: '/api/auth/signup/confirmation/',
      method: 'POST',
      data: {uid: data}
    },
    false
  );
}

export function resetPasswordAPI(data: any) {
  return request(
    {
      url: '/api/auth/reset-password/request/',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function confirmResetPasswordAPI(data: any) {
  return request(
    {
      url: '/api/auth/reset-password/do/',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function loginSocialAPI(data: any) {
  data.client_id = process.env.REACT_APP_CLIENT_ID

  return request(
    {
      url: '/api/auth/social/token',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function refreshTokenAPI(refreshToken: string) {
  const data = {
    grant_type: 'refresh_token',
    client_id: process.env.REACT_APP_CLIENT_ID,
    refresh_token: refreshToken
  }
  return request(
    {
      url: '/api/auth/token',
      method: 'POST',
      data: data,
    },
    false
  );
}

export function editProfileAPI(data: string) {
  return request(
    {
      url: '/api/v1/users/me/',
      method: 'PUT',
      data: data,
    },
    true
  );
}

export function tbRegistrationAPI() {
  return request(
    {
      url: '/api/v1/thingsboard/re-signup/',
      method: 'POST',
    },
    true
  );
}

